// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"tableControls__wrapper--3EWeQ","printableWrapper":"tableControls__printableWrapper--7o8zS","matchup":"tableControls__matchup--1jePN","scheduleDetails":"tableControls__scheduleDetails--PKkTB","buttons":"tableControls__buttons--34e7w","icons":"tableControls__icons--2-PMr","density":"tableControls__density--1pJv-","densityChange":"tableControls__densityChange--c3nE-","hideDensityChange":"tableControls__hideDensityChange--2fuJW","legendIcon":"tableControls__legendIcon--3Qts3","hideDensity":"tableControls__hideDensity--2KIlI","lastUpdatedAt":"tableControls__lastUpdatedAt--29oLS"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/tableControls.css
// module id = iiyx
// module chunks = 47